import { Box, styled } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Logo } from "../../assets/icons/logo.svg";
import styles from "./headerComponent.module.scss";
import i18next from "i18next";
import UserMenu from "./components/UserMenu";
import queryString from "query-string";
import _ from "lodash";
const RightBox = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  gap: "20px",
  height: "42px",
  marginRight: "-10px",
}));

const HeaderComponent = (isExactPage) => {
  const queries = queryString.parse(window?.location?.search);
  let exactTokenCode = _.get(queries, "code", null);
  const navigate = useNavigate();
  const navigateToHome = () => {
    if (!_.isNull(exactTokenCode)) {
      return "";
    } else {
      navigate("/");
    }
  };
  return (
    <Box className={styles.appBar} style={{ zIndex: "99999 !important" }} data-testid="HeaderComponent">
      <Box className={styles.appToolBar}>
        <Box
          className={styles.logoWrapper}
          onClick={() => navigateToHome()}
          data-testid="clickevent"
        >
          <Logo />
          <Box className={styles.title}>
            {i18next.t("Keurmerk Beheer Systeem")}
          </Box>
        </Box>

        <RightBox>
          <Box className={styles.userMenuContainer}>{<UserMenu />}</Box>
        </RightBox>
      </Box>
    </Box>
  );
};

export default HeaderComponent;
